export class SkyLinkRecordsSelectedClearSelectedAction {
  constructor(
    public key: string
  ) {}
}
